"use client";

import styles from "./index.module.scss";
import TextInput from "@/app/_components/Shared/TextInput";
import SearchIcon from "@/app/icons/search.svg";
import IconButton from "@/app/_components/Shared/IconButton";
import BlogPhoto from "@/app/images/blogphotoicon.png";
import Image from "next/image";
import {useCallback, useMemo, useState} from "react";
import Link from "next/link";

export default function Posts({posts}) {
    const [search, setSearch] = useState('');
    const onSearch = useCallback((e) => {
        setSearch(e.target.value);
    }, []);

    const filteredPosts = useMemo(() => {
        if (!search) return posts;
        return posts.filter(
            post => post.title.toLowerCase().includes(search.toLowerCase()) ||
                post.description.toLowerCase().includes(search.toLowerCase()) ||
                post.content.toLowerCase().includes(search.toLowerCase()) ||
                (Array.isArray(post.keywords) && post.keywords.some(keyword => keyword.toLowerCase().includes(search.toLowerCase()))) ||
                (!Array.isArray(post.keywords) && post.keywords.toLowerCase().includes(search.toLowerCase()))
        );
    }, [posts, search]);

    return (
        <div className={styles.container}>
            {/*<div className={styles.topics}>*/}
            {/*    <h1>Topics</h1>*/}
            {/*    {*/}
            {/*        topics.map((topic, index) => (*/}
            {/*            <h2 key={index} className={index === 0 ? styles.active : undefined}>{topic}</h2>*/}
            {/*        ))*/}
            {/*    }*/}
            {/*</div>*/}
            <div className={styles.postsContainer}>
                <div className="container-wrapper">
                    <TextInput value={search} onChange={onSearch} icon={SearchIcon}
                               placeholder="Search for the topics..."/>
                    {/*<div className={styles.mobileTopics}>*/}
                    {/*    {*/}
                    {/*        topics.map((topic, index) => (*/}
                    {/*            <h2 key={index} className={index === 0 ? styles.active : undefined}>{topic}</h2>*/}
                    {/*        ))*/}
                    {/*    }*/}
                    {/*</div>*/}
                    <div className={styles.posts}>
                        {
                            filteredPosts.map((post, index) => (
                                <div key={index} className={styles.post}>
                                    <div className={styles.postHeader}>
                                        <Image src={BlogPhoto} alt={post.title}/>
                                        <div className={styles.postTitle}>
                                            <h2>{post.title}</h2>
                                            <h6>{post.date}</h6>
                                        </div>
                                    </div>
                                    <div className={styles.description}>
                                        <p>{post.description}</p>
                                    </div>
                                    {/*<div className={styles.tags}>*/}
                                    {/*    {*/}
                                    {/*        post.keywords.split(',').map((tag, index) => (*/}
                                    {/*            <span key={index}>{tag.toUpperCase()}</span>*/}
                                    {/*        ))*/}
                                    {/*    }*/}
                                    {/*</div>*/}
                                    <Link href={`/blog/${post.slug}`}>
                                        <IconButton onClick={() => {
                                        }}>
                                            Read More
                                        </IconButton>
                                    </Link>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>

        </div>
    );
}
